import {
  getDeviceIcon,
  getObjectDescLabel,
  getObjectIconFromType,
  getExtDeviceIdentifier,
  getExtDeviceActiveLink,
  getExtDeviceIconFromType,
  getConfiguredChannelsOrModulesSettings,
  hasDeviceSettingsButtonVisible,
  hasDeviceCommandIconButtonVisible,
  getThermo99Description,
} from '@/core/utils/utils';
import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import {
  RoomDTO,
  DeviceDTO,
  ComponentType,
  RoomObjectDTO,
  RoomObjectType,
  DefaultDevicesSettingsDTO,
} from '@/../client-generator/generated-clients/plants';
import DialogCommandIcon from './DialogCommandIcon/DialogCommandIcon.vue';
import DialogObjectSettings from './DialogObjectSettings/DialogObjectSettings.vue';
import DialogConfirmDelete from '@/views/components/DialogConfirmDelete/DialogConfirmDelete.vue';
import DialogThermoObjectSettings from './DialogThermoObjectSettings/DialogThermoObjectSettings.vue';

@Options({
  name: 'RoomObjectGroup',
  props: {
    roomObject: {
      type: Object as PropType<RoomObjectDTO>,
      required: true,
    },
    room: {
      type: Object as PropType<RoomDTO>,
      required: true,
    },
    hideConfig: {
      type: Boolean,
      default: false,
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DialogConfirmDelete,
    DialogCommandIcon,
    DialogObjectSettings,
    DialogThermoObjectSettings,
  },
  emits: ['delete-object'],
})
export default class RoomObjectGroup extends Vue {
  room!: RoomDTO;
  roomObject!: RoomObjectDTO;
  getDeviceIcon = getDeviceIcon;
  getExtDeviceIconFromType = getExtDeviceIconFromType;
  getExtDeviceIdentifier = getExtDeviceIdentifier;
  getExtDeviceActiveLink = getExtDeviceActiveLink;
  RoomObjectType = RoomObjectType;
  getObjectDescLabel = getObjectDescLabel;
  getObjectIconFromType = getObjectIconFromType;
  getConfiguredChannelsOrModulesSettings = getConfiguredChannelsOrModulesSettings;
  hasDeviceSettingsButtonVisible = hasDeviceSettingsButtonVisible;
  hasDeviceCommandIconButtonVisible = hasDeviceCommandIconButtonVisible;
  getThermo99Description = getThermo99Description;

  isVisibleDialogCommandIcon = false;
  isVisibleDialogObjectSettings = false;
  isVisibleDialogThermoObjectSettings = false;
  isVisibleDeleteObjectConfirm = false;
  selectedDefaultSettings: DefaultDevicesSettingsDTO | null = null;

  get isThermoRoomObject() {
    return this.roomObject.type === RoomObjectType.Thermostat;
  }

  goToAssignObject() {
    this.$router.push({
      name:
        this.roomObject.type !== RoomObjectType.Thermostat
          ? 'page-assign-room-object'
          : 'page-assign-thermo-room-object',
      params: {
        roomObjectId: this.roomObject.id ?? -1,
      },
      query: {
        roomType: this.room.type,
        roomName: this.room.name,
      },
    });
  }

  get roomObjectDevices() {
    const devices = this.roomObject.devices;
    if (!devices) return [];
    const devicesToClone: DeviceDTO[] = [];
    for (const device of devices) {
      if (device.isAssignedActuatorAndCommand) {
        const deviceToClone = { ...device } as DeviceDTO;
        deviceToClone.selectedComponentType = ComponentType.Command;
        devicesToClone.push(deviceToClone);
      }
    }
    return devices.concat(devicesToClone);
  }

  getConfiguredChannelsOrModulesText(device: DeviceDTO) {
    return getConfiguredChannelsOrModulesSettings(device)?.activeLinksLabel;
  }

  toggleDeleteObjectConfirm() {
    this.isVisibleDeleteObjectConfirm = !this.isVisibleDeleteObjectConfirm;
  }

  async handleDeleteObject() {
    this.$emit('delete-object');
  }

  toggleDialogCommandIcon(defaultSettings: DefaultDevicesSettingsDTO) {
    this.isVisibleDialogCommandIcon = !this.isVisibleDialogCommandIcon;
    this.selectedDefaultSettings = defaultSettings;
  }

  toggleDialogObjectSettings(defaultSettings: DefaultDevicesSettingsDTO) {
    this.isVisibleDialogObjectSettings = !this.isVisibleDialogObjectSettings;
    this.selectedDefaultSettings = defaultSettings;
  }

  toggleDialogThermoObjectSettings() {
    this.isVisibleDialogThermoObjectSettings = !this
      .isVisibleDialogThermoObjectSettings;
  }
}
